// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class ReportTypesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'reportTypes';
        this.Server = this.props.context.getState().server.reportTypes;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];

        const defaultHead = [
            { id: 'name', label: 'name', alignRight: false, cell: 'Text' },
            {
                id: 'templateType',
                label: 'reportTemplateType',
                cell: 'Items',
                items: ['simple', 'laboratory', 'client'],
                alignRight: false,
                displayGrid: true
            },
            {
                id: 'templateFile',
                label: 'reportTemplate',
                alignRight: false,
                cell: 'Upload',
                displayGrid: false
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
